import React from 'react';
import { useLanguage } from '../../Providers/LanguageContext'
import SignUpButton from './SignUpButton';
import iMg1 from "../../images/ilustraciones soluciones industriales_construcción 1.png";
import iMg2 from "../../images/ilustraciones soluciones industriales_construcción 2.png";
import iMg3 from "../../images/ilustraciones soluciones industriales_construcción 3.png";
import iMg3en from "../../images/ilustraciones soluciones industriales_construcción 3 EN.png";
import AgricultureBanner from './AgricultureBanner';


const Construction = () => {
  const { language, currentLanguage } = useLanguage();

  return (

    <div>
      <AgricultureBanner construction={true} />
      <section id='agriculture_sec' style={{
        background: '#0c2637',
        padding: '0px 0px 30px 0px'
      }}>
        <div className='container-fluid'>
          <div className='row mb-5'>
            <div className='col-md-5 col-12 m-auto agriculture_box' >
              {/* <div className='agriculture_head'>
                <h3 style={{ color: "#000000" }}>{language.construction}</h3>
              </div> */}

              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000", fontSize: '42px', fontWeight: '700' }}>{language.budget_track}</h4>
                <p style={{
                  color: '#000',
                  fontSize: '20px'
                }}>{language.fisi_const_comp}</p>
              </div>
            </div>
            <div className='col-md-5 col-12 m-auto'>
              <div className='agriculture_img'>
                <img src={iMg1} className='img-fluid' alt='' />
              </div>
            </div>
          </div>

          <div className='row mb-5 row_reverse'>
            <div className='col-md-5 col-12 m-auto'>
              <div className='agriculture_img'>
                <img src={iMg2} className='img-fluid' alt='' />
              </div>
            </div>

            <div className='col-md-6 col-12 m-auto agriculture_box'>
              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000", fontSize: '42px', fontWeight: '700', textAlign: 'right' }}>{language.invoicing_pay_track}</h4>
                <p style={{
                  color: '#000',
                  fontSize: '20px'
                }}>{language.allow_const_comp}</p>
              </div>

              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000", fontSize: '42px', fontWeight: '700', textAlign: 'left' }}>{language.time_and_albour_man}</h4>
                <p style={{
                  color: '#000',
                  fontSize: '20px'
                }}>{language.fisi_const_comp_track}</p>
              </div>
            </div>
          </div>

          {/* <div className='row mb-5'>
            <div className='col-md-12 col-12'>
              <div className='agriculture_headtext'>
              
              </div>
            </div>
          </div> */}

          <div className='row mb-5'>
            <div className='col-md-5 col-12 agriculture_box'>
              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000", fontSize: '38px', fontWeight: '700' }}>{language.project_manage}</h4>
                <p style={{
                  color: '#000',
                  fontSize: '20px'
                }}>{language.fisi_const_comp_manage}</p>
              </div>


              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000", fontSize: '38px', fontWeight: '700' }}>{language.collaboration}</h4>
                <p style={{
                  color: '#000',
                  fontSize: '20px'
                }}> {language.enable_const_team}</p>
              </div>


            </div>


            <div className='col-md-6 col-12 m-auto'>
              <div className='agriculture_img'>
                {
                  currentLanguage === 'spanish'
                    ?
                    <img src={iMg3} className='img-fluid' alt='' style={{ width: "100%", maxWidth: "40%", height: "auto", marginBottom: "40px" }} />
                    :
                    <img src={iMg3en} className='img-fluid' alt='' style={{ width: "100%", maxWidth: "40%", height: "auto", marginBottom: "40px" }} />

                }
                {/* 
                <div className='registrarAnddescargar' style={{ transform: "translate(-50% , -50%)", top: "100%" }}>
                  <button className='registrar_Btn'>Registrarse</button>
                  <button className='descargar_Btn'>Descargar</button>
                </div> */}
                <SignUpButton />
              </div>
            </div>
          </div>


          {/* <div className='row mb-5'>
            <div className='col-md-6 col-12 m-auto'>
             
            </div>

            <div className='col-md-6 col-12 m-auto'>
              <div className='agriculture_img'>
                {
                  currentLanguage === 'spanish'
                    ?
                    <img src={iMg3} className='img-fluid' alt='' style={{ width: "100%", maxWidth: "40%", height: "auto", marginBottom: "40px" }} />
                    :
                    <img src={iMg3en} className='img-fluid' alt='' style={{ width: "100%", maxWidth: "40%", height: "auto", marginBottom: "40px" }} />

                }
                <SignUpButton />
              </div>
            </div>
          </div> */}



        </div>
      </section>

    </div>
  )
}

export default Construction